"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initAllstakeSdk = void 0;
const solana_1 = require("./solana");
const anchor_1 = require("@coral-xyz/anchor");
const near_1 = require("./near");
const data_service_1 = require("./data-service");
const ethereum_1 = require("./ethereum");
async function initAllstakeSdk(options) {
    if (!options.near && !options.solana && !options.ethereum) {
        throw Error('Please configure at least one of the near, solana, or ethereum options');
    }
    let near;
    let dataServiceNearOptions;
    if (options.near) {
        near = {
            strategyManagerContract: new near_1.StrategyManagerContract(options.near.contracts.strategyManagerContractId, options.near.adapter),
        };
        dataServiceNearOptions = {
            ...near,
            viewer: await options.near.adapter.near.account(''),
        };
    }
    let solana;
    let dataServiceSolanaOptions;
    if (options.solana) {
        solana = {
            strategyManagerProgram: new solana_1.StrategyManagerProgram(new anchor_1.web3.PublicKey(options.solana.programs.strategyManagerProgramId), options.solana.provider),
        };
        dataServiceSolanaOptions = {
            ...solana,
        };
    }
    let ethereum;
    let dataServiceEthereumOptions;
    if (options.ethereum) {
        ethereum = {
            strategyManagerContract: new ethereum_1.StrategyManagerContract(options.ethereum.contracts.strategyManagerContractId, options.ethereum.publicClient),
            uiDataProviderContract: new ethereum_1.UiDataProviderContract(options.ethereum.contracts.uiDataProviderContractId, options.ethereum.publicClient, options.ethereum.contracts.strategyManagerContractId),
        };
        dataServiceEthereumOptions = {
            ...ethereum,
            client: options.ethereum.publicClient,
            pendle: options.ethereum.pendle,
        };
    }
    const dataService = new data_service_1.DataService({
        pyth: options.pyth,
        coingecko: options.coingecko,
        near: dataServiceNearOptions,
        solana: dataServiceSolanaOptions,
        ethereum: dataServiceEthereumOptions,
    });
    return {
        near,
        solana,
        ethereum,
        dataService,
    };
}
exports.initAllstakeSdk = initAllstakeSdk;
//# sourceMappingURL=sdk.js.map